// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1ZKbX","header":"ReportDetails_header__1BdQO","title":"ReportDetails_title__2VlJ3","left":"ReportDetails_left__QSMhd"};